module.exports = __webpack_public_path__ + "img/personal_resources_notive-del.e9a3a66c.svg";